module.exports = __webpack_public_path__ + "media/images/master-favicon-1f859cd87b3f41f883825803223a7441.png";